export type Preview = {
  id: string;
  title: string;
  caption: string;
  img: string;
};

export const previews: Preview[] = [
  {
    id: 'vowels',
    title: 'Hangul Vowels — Core Four',
    caption: 'The 4 vowels that appear in 70% of Korean words, drawn as images you cannot forget.',
    img: 'https://cdn.magicpatterns.com/uploads/qV2pE7j5a8KHjpLsE4YJXD/Screenshot_20260914_203034_Drive.jpg',
  },
  {
    id: 'consonants',
    title: 'Consonants As Visual Icons',
    caption: 'See the shape, hear the sound: ㄱ is a gun, ㄴ is a nose, ㅁ is a mouth.',
    img: 'https://cdn.magicpatterns.com/uploads/pmTUsdYiJwsTtdzJnXw6fH/Screenshot_20260914_202754_Drive.jpg',
  },
  {
    id: 'dictionary',
    title: 'Visual Dictionary: 30 Expressions',
    caption: 'Words anchored to the places you will actually go — Hangang, Myeongdong, noraebang.',
    img: 'https://cdn.magicpatterns.com/uploads/gz3VAPDZ7C8ftsCeCnkeW5/Screenshot_20260914_202857_Drive.jpg',
  },
  {
    id: 'travel',
    title: 'Travel Survival — Set 2',
    caption: 'Food, buses, hotels and directions: the phrases you need in your first week in Korea.',
    img: 'https://cdn.magicpatterns.com/uploads/bSj3W8PPUSfojJ1hmjgusp/Screenshot_20260914_202951_Drive.jpg',
  },
  {
    id: 'kdrama',
    title: 'K-Drama Scene Breakdown',
    caption: 'A real confession scene decoded line by line: 오빠, 진짜, 사랑해, 보고 싶어.',
    img: 'https://cdn.magicpatterns.com/uploads/nguADyVh3bus3rRkBTVJhy/Screenshot_20260914_202827_Drive.jpg',
  },
  {
    id: 'fandom',
    title: 'Daily Fandom & Music',
    caption: 'The fandom vocabulary that floods comment sections: 축하해, 아이고, 대세.',
    img: 'https://cdn.magicpatterns.com/uploads/fxQavvmyGmgLSomQqRtYfe/Screenshot_20260914_203123_Drive.jpg',
  },
  {
    id: 'romance',
    title: 'The Romance Kit',
    caption: '좋아해 vs 사랑해, and 설레 — the untranslatable flutter K-Pop sings about.',
    img: 'https://cdn.magicpatterns.com/uploads/5sQgNz2TsYBh8qa6H75X5u/Screenshot_20260914_203102_Drive.jpg',
  },
  {
    id: 'emergency',
    title: 'Emergency Conversation Kit',
    caption: 'Five phrases for when your brain freezes mid-conversation and you need a way out.',
    img: 'https://cdn.magicpatterns.com/uploads/bGr1DLAWdtVbo6pEC88XCH/Screenshot_20260914_202932_Drive.jpg',
  },
];
